import React from "react";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import ForgetPasswordForm from "../../components/auth/ForgetPasswordForm";
import ForgetPasswordEmailConfirm from "../../components/auth/ForgetPasswordEmailConfirm";

const ForgetPasswordRequest = () => {
  const { Auth, inputs, shared }: DictionaryType = useGetDictionary();
  return (
    <AuthLayout>
      <div className="text-center mt-4 flex flex-col gap-4">
        <div className="flex flex-col gap-5">
          <PageTitle
            title={
              Auth?.forget_password?.forget_password_title ||
              "Update your password"
            }
          />
          <p className="text-lg font-normal leading-[22.68px] text-[#1E1850]">
            {Auth?.forget_password?.confirm_your_email_subtitle ||
              "Please confirm your email to be able to update your password"}
          </p>
        </div>

        <ForgetPasswordEmailConfirm />
      </div>
    </AuthLayout>
  );
};

export default ForgetPasswordRequest;
